import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';
import paths from 'routes/paths';

/**
 * Vendor List Columns (with tenant/warehouse aware paths)
 */
export const getVendorListColumns = (tenant, warehouse) => [
  {
    accessorKey: 'need_approval',
    header: 'Need Approval',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { need_approval } = original;
      return (
        <SubtleBadge pill bg={need_approval ? 'warning' : 'secondary'}>
          {need_approval ? 'Y' : 'N'}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'vendor_code',
    header: 'Vendor Code',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { vendor_code } = original;
      return <span>{vendor_code}</span>;
    },
  },
  {
    accessorKey: 'name',
    header: 'Vendor Name',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, name } = original;
      return (
        <Link to={paths.vendors.details(tenant, warehouse, id)}>
          <strong>{name}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'contact_name',
    header: 'Contact Name',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { contact_name } = original;
      return <span>{contact_name || '-'}</span>;
    },
  },
  {
    accessorKey: 'contact_email',
    header: 'Email',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { contact_email } = original;
      return <span>{contact_email || '-'}</span>;
    },
  },
  {
    accessorKey: 'contact_phone',
    header: 'Phone',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { contact_phone } = original;
      return <span>{contact_phone || '-'}</span>;
    },
  },
  {
    accessorKey: 'contact_city',
    header: 'Billing City',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { contact_city } = original;
      return <span>{contact_city || '-'}</span>;
    },
  },
];

/**
 * Vendor Item List Columns
 * (이건 tenant/warehouse 경로 필요 없음)
 */
export const VENDOR_ITEM_LIST_COLUMNS = [
  {
    accessorKey: 'name',
    header: 'Name',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { product } = original;
      return <span>{product?.name || '-'}</span>;
    },
  },
  {
    accessorKey: 'brand',
    header: 'Brand',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { product } = original;
      return <span>{product?.brand?.name || '-'}</span>;
    },
  },
  {
    accessorKey: 'sku',
    header: 'SKU',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { product } = original;
      return <span>{product?.sku || '-'}</span>;
    },
  },
  {
    accessorKey: 'barcode',
    header: 'Barcode',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { product } = original;
      return <span>{product?.barcode || '-'}</span>;
    },
  },
  {
    accessorKey: 'vendor_sku',
    header: 'Vendor SKU',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { vendor_sku } = original;
      return <span>{vendor_sku || '-'}</span>;
    },
  },
  {
    accessorKey: 'weight',
    header: 'Weight',
    enableSorting: false,
    meta: { valueType: 'number' },
    cell: ({ row: { original } }) => {
      const { product } = original;
      return (
        <span>
          {product?.weight?.value} {product?.weight?.unit}
        </span>
      );
    },
  },
  {
    accessorKey: 'unit_price',
    header: 'Unit Price',
    enableSorting: false,
    meta: { valueType: 'number' },
    cell: ({ row: { original } }) => {
      const { unit_price } = original;
      return <span>{unit_price || '-'}</span>;
    },
  },
  {
    accessorKey: 'comments',
    header: 'Comments',
    enableSorting: false,
    meta: { valueType: 'string' },
    cell: ({ row: { original } }) => {
      const { comments } = original;
      return <span>{comments || '-'}</span>;
    },
  },
];
